module.exports = __webpack_public_path__ + "2a1753c211e98dca567b324a45942089.png";